import {
  ReadReservationsOccupancyInsightsState,
  ReservationOccupancyInsightsActionTypes,
  READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_REQUEST,
  READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_SUCCESS,
  READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_FAILURE
} from "store/reducers/occupancy-insights/readReservationsOccupancyInsightsData/types";

const defaultState: ReadReservationsOccupancyInsightsState = {
  isLoading: false,
  errorMessage: ""
};

export default function readReservationsOccupancyInsightsData(state = defaultState, action: ReservationOccupancyInsightsActionTypes): ReadReservationsOccupancyInsightsState {
  switch (action.type) {
    case READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_RESERVATIONS_OCCUPANCY_INSIGHTS_DATA_FAILURE:
      return {
        ...state,
        contents: undefined,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};